import mockAxios, { AxiosResponse } from 'axios';
import { IContractServiceMock } from './contract.mock.types';

export const mockContractService = (): IContractServiceMock => ({
  fetchContracts: jest.fn(),
  fetchContract: jest.fn(),
  createContract: jest.fn(),
  updateContract: jest.fn(),
  deleteContract: jest.fn(),

  updateContractState: jest.fn(),
  initiateContractRenewal: jest.fn(),
  confirmRenewal: jest.fn(),

  addContractAttachment: jest.fn(),
  removeContractAttachment: jest.fn(),
  downloadContractAttachment: jest.fn(),

  fetchContractItems: jest.fn(),
  fetchContractItem: jest.fn(),
  createContractItem: jest.fn(),
  updateContractItem: jest.fn(),
  deleteContractItem: jest.fn()
});

export function mockContractAxiosResponse<T = any>(
  data?: T
): AxiosResponse<T | undefined> {
  return {
    data: data,
    status: 200,
    statusText: 'OK',
    headers: mockAxios.defaults.headers,
    config: mockAxios.defaults
  };
}
